import axios from "axios";
import { PayloadAuthenticated } from "@tt-app/models";
import { getLanguage } from "@tt-app/utils/internal/i18n";

const baseURL = process.env.VUE_APP_API_BASE_URL;
const apiKey = process.env.VUE_APP_API_KEY;

class Base {
  httpClient = axios.create({
    baseURL,
    headers: {
      // http://joyz-internal-documentation.s3-website-ap-northeast-1.amazonaws.com/projects/public/common/common.html#making-an-api-call
      "application-key": apiKey
    }
  });

  buildAuthHeaders = (payload: PayloadAuthenticated): { [key: string]: string } => ({
    Authorization: `Token ${payload.token}`,
    "Lingos-Users-Alias-Uuid": payload.aliasUuid
  });

  /**
   * Build the `lang` header with a fallback to English with a 0.5 weight in case
   * an invalid language is returned
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language
   */
  buildLangHeader = (): { [key: string]: string } => ({
    "Accept-Language": `${getLanguage()};q=0.9, en;q=0.5`
  });

  /**
   * Some query (e.g. conversation loading) does not use the "Accept-Language" header
   * but rely on the `lang=` query parameter to define the content language
   */
  buildLangQueryParam = (): string => `lang=${getLanguage()}`;
}

export { Base };
